"use client";

import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { AnimatedCounter } from "@/components/motion/AnimatedCounter";
import { LottieIcon } from "@/components/motion/LottieIcon";
import { MotionIcon } from "@/components/motion/MotionIcon";
import { cn } from "@/lib/utils";

interface ImpactStatCardProps {
  lottieSrc?: string;
  fallbackIcon: LucideIcon;
  value?: number;
  suffix?: string;
  prefix?: string;
  label: string;
  valueClassName?: string;
  className?: string;
  displayValue?: ReactNode;
  iconVariant?: "default" | "brand";
}

export function ImpactStatCard({
  lottieSrc,
  fallbackIcon: Icon,
  value,
  suffix = "",
  prefix = "",
  label,
  valueClassName,
  className,
  displayValue,
  iconVariant = "default",
}: ImpactStatCardProps) {
  return (
    <div className={cn("text-center", className)}>
      <div className="mb-2 flex justify-center">
        {iconVariant === "brand" ? (
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[var(--programs-green)] text-white">
            <Icon size={20} aria-hidden />
          </div>
        ) : lottieSrc ? (
          <LottieIcon
            src={lottieSrc}
            fallbackIcon={Icon}
            size={36}
            pulseOnView
          />
        ) : (
          <MotionIcon
            icon={Icon}
            size={28}
            pulseOnView
            className="text-primary"
          />
        )}
      </div>
      <p className={cn("text-2xl font-bold text-accent", valueClassName)}>
        {displayValue ?? (
          <>
            {prefix}
            {value !== undefined && (
              <AnimatedCounter value={value} suffix={suffix} />
            )}
          </>
        )}
      </p>
      <p className="text-xs text-muted mt-1">{label}</p>
    </div>
  );
}
